import React from 'react';
import { getStyles } from '../../../theme/styles';
import { Typography, Card, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCourseState } from '../../../context/CourseContext';
import { useDeliveryStrings } from '../../Courses/useDeliveryStrings';
import { courseLocation } from '../Selectors/ContentCourseDetails';

const CourseInfoCard = styled(Card)(({ theme }) => ({
  background: '#fff',
  width: '100%',
  margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  minHeight: 175,
}));

interface ContentCourseCardProps {
  className?: string;
  inPanel?: boolean;
}

export default function ContentCourseCard({ className, inPanel }: ContentCourseCardProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const { course } = useCourseState();
  const { getFrequencyString, getAvailabilityString, getQuantityString } = useDeliveryStrings();

  const deliveryRules = {
    frequencyType: course?.frequencyType,
    frequencyPayload: course?.frequencyPayload,
    availabilityType: course?.availabilityType,
    availabilityPayload: course?.availabilityPayload,
  }

  return (
    <CourseInfoCard
      variant='outlined'
      className={className}
      sx={inPanel ? { margin: `${theme.spacing(1, 0)}`, boxSizing: 'border-box' } : undefined}
    >
      <Typography variant='h6' component='h6' sx={styles.customerCard_caption}>
        {course?.courseName}
      </Typography>
      <Typography variant='body1' component='p' sx={styles.customerCard_content}>
        Grades: {course?.grades.join(',')}<br/>
        Location: {course && courseLocation(course)}<br/>
        Total Lessons: {course?.lessons.length} <br />
        Default Course Grade(s): {course?.grades.join(', ')} <br />
        Default Delivery Schedule: <br />
         - Availability: {getAvailabilityString(deliveryRules)} <br />
         - Frequency: {getFrequencyString(deliveryRules)} <br />
         - Lessons to deliver: {getQuantityString(deliveryRules)} <br />
      </Typography>
    </CourseInfoCard>
  );
}
